import React from "react";

export default props => (
  <div
    className="positioner"
    style={{
      position: "absolute",
      top: props.top,
      left: props.left,
      zIndex: props.zIndex,
      pointerEvents: props.locked ? "none" : "auto"
    }}>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ./src/canvas/enhancers/positionable.js